import {SpriteButton} from '@fantasmagames/core/src/display/SpriteButton';
import {ButtonState} from '@fantasmagames/core/src/display/Button';
import {ObjectSize, Position} from '@fantasmagames/slot/src/modules/reels/ReelConstants';
import {NineSlicePlane} from '@fantasmagames/core/src/display/NineSlicePlane';

export class NineSliceSpriteButton extends SpriteButton {
	public setFrames(up: NineSlicePlane, down?: NineSlicePlane, over?: NineSlicePlane, disabled?: NineSlicePlane): void {
		this._frames[ButtonState.UP] = up;
		this._frames[ButtonState.DOWN] = down ? down : up;
		this._frames[ButtonState.OVER] = over ? over : up;
		this._frames[ButtonState.DISABLED] = disabled ? disabled : up;

		this.updateFrame();
	}

	public setSize(newSize: ObjectSize): void {
		this.updateNineSliceSize(ButtonState.UP, newSize);
		this.updateNineSliceSize(ButtonState.DOWN, newSize);
		this.updateNineSliceSize(ButtonState.OVER, newSize);
		this.updateNineSliceSize(ButtonState.DISABLED, newSize);
	}

	public setWidth(newWidth: number): void {
		this.setFrameWidth(ButtonState.UP, newWidth);
		this.setFrameWidth(ButtonState.DOWN, newWidth);
		this.setFrameWidth(ButtonState.OVER, newWidth);
		this.setFrameWidth(ButtonState.DISABLED, newWidth);
	}

	public setHeight(newHeight: number): void {
		this.setFrameWidth(ButtonState.UP, newHeight);
		this.setFrameWidth(ButtonState.DOWN, newHeight);
		this.setFrameWidth(ButtonState.OVER, newHeight);
		this.setFrameWidth(ButtonState.DISABLED, newHeight);
	}

	protected setFrameWidth(stateObject: ButtonState, newWidth: number): void {
		this._frames[stateObject].width = newWidth;
		this._frames[stateObject].updatePositionFromAnchor();
	}

	protected setFrameHeight(stateObject: ButtonState, newHeight: number): void {
		this._frames[stateObject].height = newHeight;
		this._frames[stateObject].updatePositionFromAnchor();
	}

	public updateNineSliceSize(stateObject: ButtonState, newSize: ObjectSize): void {
		this._frames[stateObject].width = newSize.width;
		this._frames[stateObject].height = newSize.height;
		this._frames[stateObject].updatePositionFromAnchor();
	}

	public setAnchor(newPosition: Position): void {
		this._frames[ButtonState.UP].anchor = newPosition;
		this._frames[ButtonState.DOWN].anchor = newPosition;
		this._frames[ButtonState.OVER].anchor = newPosition;
		this._frames[ButtonState.DISABLED].anchor = newPosition;

		this._frames[ButtonState.UP].updatePositionFromAnchor();
		this._frames[ButtonState.DOWN].updatePositionFromAnchor();
		this._frames[ButtonState.OVER].updatePositionFromAnchor();
		this._frames[ButtonState.DISABLED].updatePositionFromAnchor();
	}
}



// WEBPACK FOOTER //
// ./@fantasmagames/core/src/display/NineSliceSpriteButton.ts